export default __webpack_public_path__ + "media/images/images/backgrounds/todo-45727b3f4cc0cf60f51ecba0dac97aec.jpeg";